/**Основные состояния приложения */
export enum AppViewStates {
  initial = 0,
  login = 1,
  code = 2,
  snippets = 3,
  settings = 4
}
